// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__Y9spV","modalForm":"UpgradeEpcsModal_modalForm__1Hr_L","modalFooter":"UpgradeEpcsModal_modalFooter__7SvC-"};